<template>
  <div class="add-device">
    <div class="add-white-wrap" v-if="!isShowLimit">
      <div class="close-icon" @click="closeClick"></div>
      <div class="add-title">添加设备</div>
      <div class="add-text">输入设备端设备绑定码绑定</div>
      <div class="code-wrap">
        <div class="tips">{{ inputTips }}</div>
        <input
          v-model="activecode"
          v-on:input="inputFun()"
          @focus="onInputFocus"
          @blur="onInputBlur"
          @keydown.enter="bindDeviceClick"
        />
      </div>
      <div class="btn" @click="bindDeviceClick">立即绑定</div>
      <div
        class="getcode"
        @click="showDownloadClick"
        v-if="!$store.getters.isAppstoreMode"
      >
        <div class="getcode-icon"></div>
        如何获取绑定码？
      </div>
    </div>
    <Download v-if="$store.state.isShowDownload == 1"></Download>
    <ChooseFirm v-if="$store.state.isShowDownload == 2"></ChooseFirm>
    <DownloadQh v-if="$store.state.isShowDownload == 3"></DownloadQh>
    <DownloadWlt v-if="$store.state.isShowDownload == 4"></DownloadWlt>
    <DownloadTwm v-if="$store.state.isShowDownload == 5"></DownloadTwm>
    <DownloadLx v-if="$store.state.isShowDownload == 6"></DownloadLx>
    <DownloadHk v-if="$store.state.isShowDownload == 7"></DownloadHk>
    <DownloadWin v-if="$store.state.isShowDownload == 8"></DownloadWin>
    <DownloadMac v-if="$store.state.isShowDownload == 9"></DownloadMac>

    <div class="add-limit-wrap" v-if="isShowLimit">
      <div class="limit-close" @click="closeClick"></div>
      <div class="limit-title">设备超限</div>
      <div class="limit-text">
        当前限绑
        <span>{{ $store.state.limit.bind.normal }}</span> 台设备
      </div>
      <div class="limit-item">
        <div class="item-text">开通高级会员</div>
        <div class="item-text item-text2">畅享设备绑定</div>
      </div>
      <div class="limit-item2"></div>
      <div class="limit-item3">
        <div class="item3-text">
          <div class="item3-icon"></div>
          不限访问次数
        </div>
        <div class="item3-text">
          <div class="item3-icon item3-icon2"></div>
          不限设备数量
        </div>
        <div class="item3-text">
          <div class="item3-icon item3-icon3"></div>
          享受高速带宽
        </div>
      </div>
      <div class="limit-btns">
        <div class="btn" @click="closeClick">取消</div>
        <div class="btn btn2" @click="goPayClick">立即开通</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Download from "@/components/remote/Download.vue";
import ChooseFirm from "@/components/remote/ChooseFirm.vue";
import DownloadQh from "@/components/remote/DownloadQh.vue";
import DownloadWlt from "@/components/remote/DownloadWlt.vue";
import DownloadTwm from "@/components/remote/DownloadTwm.vue";
import DownloadLx from "@/components/remote/DownloadLx.vue";
import DownloadHk from "@/components/remote/DownloadHk.vue";
import DownloadWin from "@/components/remote/DownloadWin.vue";
import DownloadMac from "@/components/remote/DownloadMac.vue";
export default {
  name: "AddDevice",
  data: function () {
    return {
      activecode: "",
      inputTips: "输入绑定码",
      isShowLimit: false,
    };
  },
  components: {
    Download,
    ChooseFirm,
    DownloadQh,
    DownloadWlt,
    DownloadTwm,
    DownloadLx,
    DownloadHk,
    DownloadWin,
    DownloadMac,
  },
  props: ["deviceLength"],
  methods: {
    ...mapActions(["bookRegister", "sendUserlog"]),
    goPayClick: function () {
      this.closeClick();
      this.$router.push("/home/vip");
    },
    showDownloadClick: function () {
      let _that = this;
      _that.$store.state.isShowDownload = 1;
    },
    closeClick: function () {
      let _that = this;
      _that.$emit("closeAddDeviceClick");
    },
    inputFun: function () {
      let _that = this;
      if (_that.activecode.length > 6) {
        _that.activecode = _that.activecode.slice(0, 6);
      }
    },
    onInputFocus: function () {
      this.inputTips = "";
    },
    onInputBlur: function () {
      if (!this.activecode) {
        this.inputTips = "输入绑定码";
      }
    },
    bindDeviceClick: function () {
      let _that = this;
      if (!_that.activecode) {
        _that.$store.state.toast = "请输入绑定码";
        return;
      } else if (_that.activecode.length < 6) {
        _that.$store.state.toast = "绑定码无效";
        return;
      }
      _that.bookRegister([
        _that.activecode,
        function (err, data) {
          if (data && !data.rtn && data.register) {
            _that.$store.state.toast = "绑定成功";
            setTimeout(function () {
              _that.$emit("closeAddDeviceClick");
            }, 3000);

            _that.$emit("getBindget");

            _that.$store.state.isLoadForBind = true;

            _that.sendUserlog(["bindDevice_s", _that.activecode]);
          } else {
            _that.$store.state.toast = "绑定失败";
            setTimeout(function () {
              _that.$emit("closeAddDeviceClick");
            }, 3000);

            // 绑定失败
            if (data && data.rtn == 10216) {
              _that.sendUserlog([
                "bindDevice_f_limit",
                _that.activecode + "|10216",
              ]);
            } else {
              _that.sendUserlog([
                "bindDevice_f",
                _that.activecode + "|" + data.rtn,
              ]);
            }
          }
        },
      ]);
    },
  },
  mounted() {
    let _that = this;
    if (
      _that.$store.state.user.vip_left <= 0 &&
      _that.deviceLength >= _that.$store.state.limit.bind.normal
    ) {
      this.isShowLimit = true;
    } else if (
      _that.$store.state.user.vip_left > 0 &&
      _that.deviceLength >= _that.$store.state.limit.bind.vip
    ) {
      this.isShowLimit = true;
    }
  },
};
</script>

<style lang="less" scoped>
.add-device {
  position: absolute;
  left: 0;
  top: 0;
  background-color: rgba(50, 50, 50, 0.5);
  width: 100%;
  height: 100%;
  z-index: 998;
  .add-white-wrap {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 345px;
    height: 330px;
    background-color: #ffffff;
    border-radius: 8px;
    .close-icon {
      position: absolute;
      right: 16px;
      top: 16px;
      width: 24px;
      height: 24px;
      background-image: url("../../assets/device/close.svg");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      cursor: pointer;
    }
    .add-title {
      margin-top: 47px;
      font-weight: 600;
      font-size: 20px;
      line-height: 28px;
      text-align: center;
      color: #1f1f1f;
    }
    .add-text {
      margin-top: 15px;
      text-align: center;
      color: #666666;
      font-size: 14px;
      line-height: 20px;
    }
    .code-wrap {
      position: relative;
      margin: 0 auto;
      margin-top: 20px;
      width: 286px;
      height: 48px;
      border: 1px solid #cbcdd1;
      box-shadow: 0px 2px 6px rgba(201, 206, 210, 0.2);
      border-radius: 86px;
      overflow: hidden;
      background-color: #fcfdff;

      .tips {
        position: absolute;
        left: 0;
        top: 0;
        width: 286px;
        height: 48px;
        text-align: center;
        line-height: 48px;
        font-size: 16px;
        color: #666666;
      }
      input {
        position: absolute;
        left: 0;
        top: 0;
        text-align: center;
        width: 286px;
        height: 48px;
        background-color: transparent;
        letter-spacing: 10px;
        color: #143977;
        font-weight: 700;
        font-size: 24px;
        font-family: "DIN";
      }
    }
    .btn {
      margin: 0 auto;
      margin-top: 24px;
      width: 286px;
      height: 48px;
      background: linear-gradient(173deg, #133977 4%, #103570 132%);
      background: linear-gradient(
        189deg,
        #6c69fe 0%,
        #4c49ec 35.94%,
        #29439d 99.24%
      );
      box-shadow: 0px 4px 12px rgba(172, 178, 186, 0.2);
      border-radius: 24px;
      font-weight: 700;
      font-size: 16px;
      line-height: 48px;
      text-align: center;
      color: #fcfcfc;
      cursor: pointer;
    }
    .btn:hover {
      opacity: 0.9;
    }
    .getcode {
      margin-top: 16px;
      text-align: center;
      font-size: 14px;
      line-height: 22px;
      color: #143977;
      cursor: pointer;
      .getcode-icon {
        display: inline-block;
        margin-right: 4px;
        vertical-align: top;
        width: 20px;
        height: 20px;
        background-image: url("../../assets/remote/getcode.svg");
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
    }
  }
  .add-limit-wrap {
    padding-top: 1px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 422px;
    height: 350px;
    border-radius: 8px;
    background: linear-gradient(180deg, #fceee3 0%, #ffffff 24%);
    box-shadow: 0px 8px 16px rgba(72, 68, 62, 0.4);
    border-radius: 8px;
    box-sizing: border-box;
    .limit-close {
      position: absolute;
      right: 0;
      top: 0;
      background-image: url("../../assets/remote/control6.svg");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      width: 46px;
      height: 46px;
      cursor: pointer;
    }
    .limit-title {
      margin-top: 34px;
      font-weight: 600;
      font-size: 20px;
      line-height: 28px;
      text-align: center;
      color: #1a1a1a;
    }
    .limit-text {
      margin-top: 4px;
      font-size: 12px;
      line-height: 18px;
      color: #c1c1c1;
      text-align: center;
      span {
        font-weight: 600;
        color: #ff4b4b;
      }
    }
    .limit-item {
      margin-top: 10px;
      text-align: center;
      .item-text {
        display: inline-block;
        vertical-align: top;
        font-weight: 600;
        font-size: 18px;
        line-height: 25px;
        color: #694516;
      }
      .item-text2 {
        margin-left: 24px;
      }
    }
    .limit-item2 {
      margin-top: 22px;
      margin-left: 160px;
      width: 198px;
      height: 138px;
      background-image: url("../../assets/device/limit1.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .limit-item3 {
      position: absolute;
      top: 128px;
      left: 90px;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      color: #694516;
      .item3-text {
        margin-top: 12px;
        .item3-icon {
          display: inline-block;
          margin-right: 8px;
          vertical-align: top;
          background-image: url("../../assets/device/limit2.svg");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          width: 16px;
          height: 17px;
        }
        .item3-icon2 {
          background-image: url("../../assets/device/limit3.svg");
        }
        .item3-icon3 {
          background-image: url("../../assets/device/limit4.svg");
        }
        .item3-icon4 {
          background-image: url("../../assets/device/limit5.svg");
        }
      }
    }
    .limit-btns {
      text-align: center;
      .btn {
        display: inline-block;
        vertical-align: top;
        width: 120px;
        height: 42px;
        line-height: 42px;
        background-color: #fff7f0;
        border: 1px solid #eee3d9;
        border-radius: 40px;
        font-size: 14px;
        color: #694516;
        box-sizing: border-box;
        cursor: pointer;
      }
      .btn2 {
        margin-left: 16px;
        border: none;
        background-image: linear-gradient(270deg, #724007 2%, #9f6f21 94%);
        font-weight: 600;
        font-size: 14px;
        color: #ffffff;
      }
    }
  }
}
</style>